/** UI layout modes only — not simulation modes. */

export type ShellLayoutMode = 'portrait' | 'landscape' | 'desktop'

/**
 * Resolve match workspace chrome from available viewport geometry.
 * Square cells / GameSession are unaffected.
 */
export function resolveShellLayoutMode(
  width: number,
  height: number
): ShellLayoutMode {
  const w = Math.max(0, width)
  const h = Math.max(0, height)
  // Wide + tall enough: intentional desktop workspace with side rail.
  if (w >= 1024 && h >= 640) return 'desktop'
  // Short wide viewports: reclaim vertical space for the Phaser stage.
  if (w > h && h < 560) return 'landscape'
  return 'portrait'
}

/** Deliberate max workspace width on large monitors (gutters outside). */
export const DESKTOP_WORKSPACE_MAX_PX = 1440
